// Module
var code = `<h2 class="section-header history-header">
  Remittance History
  <button ng-click="\$ctrl.reloadHistory()" class="btn">Refresh History</button>
</h2>

<table ng-table="\$ctrl.batchRemittanceHistoryService.getHistory()" class="table">
  <thead>
  <tr>
    <th>No</th>
    <th>Uploaded on</th>
    <th>Applicable Period</th>
    <th>File name</th>
    <th>Official receipt</th>
    <th>Branch of service</th>
    <th>Status</th>
    <th>Rows count</th>
    <th>Pass count</th>
    <th>Fail count</th>
    <th>Pass report</th>
    <th>Fail report</th>
    <th>Revert</th>
  </tr>
  </thead>
  <tr ng-repeat="batchRemittanceHistoryRow in \$data">
    <td>{{\$index + 1 + (\$ctrl.batchRemittanceHistoryService.getHistory().page() - 1) * \$ctrl.batchRemittanceHistoryService.getHistory().count()}}</td>
    <td>{{batchRemittanceHistoryRow.uploadedOn | prettyDateTime}}</td>
    <td>{{batchRemittanceHistoryRow.applicablePeriod}}</td>
    <td>{{batchRemittanceHistoryRow.fileName}}</td>
    <td>{{batchRemittanceHistoryRow.officialReceipt}}</td>
    <td>{{\$ctrl.getBranchOfServiceLabel(batchRemittanceHistoryRow.branchOfService)}}</td>
    <td>
      {{batchRemittanceHistoryRow.status | prettyEnum}}
      <help ng-if="batchRemittanceHistoryRow.status === 'FAILED'" ng-click="\$ctrl.showErrorDetails(batchRemittanceHistoryRow.errorMessage)" title="More details"></help>
    </td>
    <td>{{batchRemittanceHistoryRow.rowCount}}</td>
    <td>{{batchRemittanceHistoryRow.processedCount}}</td>
    <td>{{batchRemittanceHistoryRow.failedCount}}</td>
    <td>
      <button ng-click="\$ctrl.downloadPassReport(batchRemittanceHistoryRow.id)" ng-disabled="batchRemittanceHistoryRow.processedCount <= 0" class="btn btn-primary">Pass report</button>
    </td>
    <td>
      <button ng-click="\$ctrl.downloadFailReport(batchRemittanceHistoryRow.id)" ng-disabled="batchRemittanceHistoryRow.failedCount <= 0" class="btn btn-warning">Fail report</button>
    </td>
    <td>
      <button command-access="BatchRemittanceRevert" ng-click="\$ctrl.revert(batchRemittanceHistoryRow)" ng-disabled="\$ctrl.isRevertNotAllowed(batchRemittanceHistoryRow.status) || batchRemittanceHistoryRow.processedCount === 0" class="btn btn-primary">Revert</button>
    </td>
  </tr>
</table>

<div ng-if="!\$ctrl.batchRemittanceHistoryService.getTotalRowCount()" class="empty-message">
  <span>Batch remittance history is blank</span>
</div>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/batch/remittance/batch-remittance-history.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;